import React, { useMemo } from 'react';

import TagDescriptionsSC, {
  TagDescriptionDotSC,
  TagDescriptionSC,
} from './tag-descriptions.styled';
import { TUnknownObject } from '@common/types/common';
import { TEventType } from '@custom-types/user-interface';
import Star from '@common/components/star/star';

type TagDescriptionProps = {
  slots: TUnknownObject[];
};

const TagDescriptions: React.FC<TagDescriptionProps> = ({ slots }) => {
  const descriptions = useMemo(() => {
    const descriptionsObj = slots.reduce((acc, e) => {
      if (e.tag && !acc[e.tag.id]) {
        acc[e.tag.id] = {
          color: e.tag.color,
          text: e.tag.name,
          type: e.type,
        };
      }
      return acc;
    }, {} as Record<string, { color: string; text: string; type: TEventType }>);

    return Object.values(descriptionsObj);
  }, [slots]);

  return (
    <TagDescriptionsSC>
      {descriptions.map((description, i) => {
        return (
          <TagDescriptionSC key={i}>
            {description.type === 'free' ? (
              <TagDescriptionDotSC background={description.color} />
            ) : (
              <div className={'star-container'}>
                <Star
                  color={description.color}
                  className={'description-star'}
                />
              </div>
            )}
            <span style={{ color: description.color }} className={'name'}>
              {description.text}
            </span>
          </TagDescriptionSC>
        );
      })}
    </TagDescriptionsSC>
  );
};

export default TagDescriptions;
